import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LikesGuard  {
  constructor(private store: Store<fromStore.RootLikesState>) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getLikesInitialized).pipe(
      tap(initialized => {
        if (!initialized) {
          this.store.dispatch(fromStore.InitLikes());
        }
      }),
      filter(initialized => initialized),
      take(1)
    );
  }
}
